import { ApiPortfolioStatus } from '@/api'

import { ContentHeight, PortfolioApprovalStatus } from '../constants'

export const getContentHeight = (approvalStatus: ApiPortfolioStatus, isNew: boolean): number => {
  const isRejected = [
    PortfolioApprovalStatus.REJECTED_NEW,
    PortfolioApprovalStatus.REJECTED_EDIT
  ].includes(approvalStatus as PortfolioApprovalStatus)

  if (isRejected) return ContentHeight.REJECTED_HEIGHT
  return isNew ? ContentHeight.ISNEW_HEIGHT : ContentHeight.STANDARD_HEIGHT
}
